import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-5">
          <div className="w-1 h-5 rounded-full bg-primary-500"></div>
          <h2 className="font-heading text-lg font-bold text-foreground-900">热门分类</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-lg text-primary-500`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500">{cat.articleCount}篇</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}